/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ListExistingByProductsFragment = {
  __typename?: 'SProductsQuery';
  listExistingByProducts?: {
    __typename?: 'SProductList';
    positions?: Array<number>;
    isFirstMF: boolean;
    products: Array<{
      __typename?: 'SProduct';
      adPayer: Types.AdPayer;
      adTrackingData: string;
      mgr?: number;
      channelOffer?: { __typename?: 'ChannelOffer'; productId: string };
    }>;
  };
};

export type SpDataAddToCartPageQueryVariables = Types.Exact<{
  context: Types.SContentContext;
  products: Types.SProductsExistingByProducts;
}>;

export type SpDataAddToCartPageQuery = {
  __typename?: 'Query';
  sProducts?: {
    __typename?: 'SProductsQuery';
    listExistingByProducts?: {
      __typename?: 'SProductList';
      positions?: Array<number>;
      isFirstMF: boolean;
      products: Array<{
        __typename?: 'SProduct';
        adPayer: Types.AdPayer;
        adTrackingData: string;
        mgr?: number;
        channelOffer?: { __typename?: 'ChannelOffer'; productId: string };
      }>;
    };
  };
};

export type SpDataCartPageQueryVariables = Types.Exact<{
  context: Types.SContentContext;
  products: Types.SProductsExistingByProducts;
}>;

export type SpDataCartPageQuery = {
  __typename?: 'Query';
  sProducts?: {
    __typename?: 'SProductsQuery';
    listExistingByProducts?: {
      __typename?: 'SProductList';
      positions?: Array<number>;
      isFirstMF: boolean;
      products: Array<{
        __typename?: 'SProduct';
        adPayer: Types.AdPayer;
        adTrackingData: string;
        mgr?: number;
        channelOffer?: { __typename?: 'ChannelOffer'; productId: string };
      }>;
    };
  };
};

export const ListExistingByProductsFragmentDoc = /*#__PURE__*/ `
    fragment listExistingByProducts on SProductsQuery {
  listExistingByProducts(context: $context, products: $products) {
    products {
      adPayer
      adTrackingData
      mgr
      channelOffer {
        productId
      }
    }
    positions
    isFirstMF
  }
}
    `;
export const SpDataAddToCartPageDocument = /*#__PURE__*/ `
    query SpDataAddToCartPage($context: SContentContext!, $products: SProductsExistingByProducts!) {
  sProducts: sProducts {
    ...listExistingByProducts
  }
}
    ${ListExistingByProductsFragmentDoc}`;

export function useSpDataAddToCartPageQuery(
  options: Omit<Urql.UseQueryArgs<SpDataAddToCartPageQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    SpDataAddToCartPageQuery,
    SpDataAddToCartPageQueryVariables
  >({ query: SpDataAddToCartPageDocument, ...options });
}
export const SpDataCartPageDocument = /*#__PURE__*/ `
    query SpDataCartPage($context: SContentContext!, $products: SProductsExistingByProducts!) {
  sProducts: sProducts {
    ...listExistingByProducts
  }
}
    ${ListExistingByProductsFragmentDoc}`;

export function useSpDataCartPageQuery(
  options: Omit<Urql.UseQueryArgs<SpDataCartPageQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SpDataCartPageQuery, SpDataCartPageQueryVariables>({
    query: SpDataCartPageDocument,
    ...options,
  });
}
